module.exports = __webpack_public_path__ + "static/media/VWGoA_Logo.f38945f7.png";